// extracted by mini-css-extract-plugin
export var about = "valpar-module--about--265OH";
export var content = "valpar-module--content--13Pj5";
export var contentFlex = "valpar-module--contentFlex--29fMd";
export var image = "valpar-module--image--3W8Jm";
export var paragraph = "valpar-module--paragraph--2SOeJ";